import root from 'window-or-global';
import type { HeaderProps } from '@layout/components/Header/Header';

export const getSignInLink = (
  { epicAccountPortalBaseUrl, epicAccountPortalBasePath, epicServiceClientId },
  resolvedPath: string = ''
) => {
  const signInLink = `${epicAccountPortalBaseUrl}${epicAccountPortalBasePath}/login?redirectUrl=${root.location.origin}${resolvedPath}&clientId=${epicServiceClientId}&noHostRedirect=true`;
  return signInLink;
};

export function getSignOutLink(
  { epicAccountPortalBaseUrl, epicAccountPortalBasePath, epicServiceClientId }: HeaderProps['publicRuntimeSettings'],
  resolvedPath: string
) {
  const signOutLink = `${epicAccountPortalBaseUrl}${epicAccountPortalBasePath}/logout?redirectUrl=${root.location.origin}${resolvedPath}&clientId=${epicServiceClientId}&noHostRedirect=false`;

  return signOutLink;
}
